import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { Bounce, toast, ToastContainer, ToastOptions } from 'react-toastify';
type Props = {};
type Ref = {
  success: (msg: string) => void;
  error: (msg: string) => void;
  warning: (msg: string) => void;
};
export const useToastUIRef = () => useRef<Ref>(null);
export const globalToastUIRef = React.createRef<Ref>();
const toastOptions: ToastOptions = {
  position: 'top-right',
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: false,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: 'colored',
  transition: Bounce,
};
const ToastUI = forwardRef<Ref, Props>(({ }, ref) => {
  const contextHolder = <ToastContainer
    position="top-right"
    autoClose={5000}
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick={false}
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
    theme="colored"
    transition={Bounce}
  />;

  const success = (content: string) => toast.success(content, toastOptions);

  const error = (content: string) => toast.error(content, toastOptions);

  const warning = (content: string) => toast.warn(content, toastOptions);

  useImperativeHandle(ref, () => ({
    success, error, warning,
  }));
  return (<>{contextHolder}</>);
});
ToastUI.displayName = 'ToastUI';
export default ToastUI;